<template>

    <div class="loader" v-show="isloading">

        <img src="../../assets/logo.png" alt="Carregando..." />
        <div class="spinner">
            <div class="dot1"></div>
            <div class="dot2"></div>
        </div>

    </div>

</template>
<script>

    export default {
        name: "loading",
        data() {
            return {
                isloading: false
            };
        },
        mounted() {
            this.$eventHub.$on('show-loading', (show) => {
                this.isloading = show;
            })
        },
        beforeDestroy() {
            this.$eventHub.$off('show-loading');
        },
    };
</script>
<style>
    .loader {
        position: fixed;
        z-index: 9999;
        background: rgba(255, 255, 255, 0.8);
        filter: alpha(opacity=60);
        width: 100%;
        height: 100%;
    }

        .loader img {
            display: block;
            margin: 200px auto;
            margin-bottom: 0;
            width: 200px;
            /*-webkit-animation: sk-rotateplane 3s infinite ease-in-out;
            animation: sk-rotateplane 3s infinite ease-in-out;*/
        }

    .spinner {
        margin: 0 auto;
        width: 40px;
        height: 40px;
        position: relative;
        text-align: center;
        -webkit-animation: sk-rotate 2.0s infinite linear;
        animation: sk-rotate 2.0s infinite linear;
    }

    .dot1, .dot2 {
        width: 60%;
        height: 60%;
        display: inline-block;
        position: absolute;
        top: 0;
        background-color: #FF113A;
        border-radius: 100%;
        -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
        animation: sk-bounce 2.0s infinite ease-in-out;
    }

    .dot2 {
        top: auto;
        bottom: 0;
        -webkit-animation-delay: -1.0s;
        animation-delay: -1.0s;
        background-color: #1a1a82;
    }

    @-webkit-keyframes sk-rotate {
        100% {
            -webkit-transform: rotate(360deg)
        }
    }

    @keyframes sk-rotate {
        100% {
            transform: rotate(360deg);
            -webkit-transform: rotate(360deg)
        }
    }

    @-webkit-keyframes sk-bounce {
        0%, 100% {
            -webkit-transform: scale(0.0)
        }

        50% {
            -webkit-transform: scale(1.0)
        }
    }

    @keyframes sk-bounce {
        0%, 100% {
            transform: scale(0.0);
            -webkit-transform: scale(0.0);
        }

        50% {
            transform: scale(1.0);
            -webkit-transform: scale(1.0);
        }
    }

    /*@-webkit-keyframes sk-rotateplane {
        0% {
            -webkit-transform: perspective(110px) rotateY(0deg);
        }

        25% {
            -webkit-transform: perspective(110px) rotateY(180deg);
        }

        50% {
            -webkit-transform: perspective(110px) rotateY(360deg) rotateX(180deg);
        }

        75% {
            -webkit-transform: perspective(110px) rotateY(180deg);
        }

        100% {
            -webkit-transform: perspective(110px) rotateY(0deg);
        }
    }

    @keyframes sk-rotateplane {

        0% {
            transform: perspective(110px) rotateY(0deg);
            -webkit-transform: perspective(110px) rotateY(0deg);
        }

        25% {
            transform: perspective(110px) rotateY(180deg);
            -webkit-transform: perspective(110px) rotateY(180deg);
        }

        50% {
            transform: perspective(110px) rotateY(360deg);
            -webkit-transform: perspective(110px) rotateY(360deg) rotateX(180deg);
        }

        75% {
            transform: perspective(110px) rotateY(180deg);
            -webkit-transform: perspective(110px) rotateY(180deg);
        }

        100% {
            transform: perspective(110px) rotateY(0deg);
            -webkit-transform: perspective(110px) rotateY(0deg);
        }
    }*/
</style>